<template>
  <div>
    <b-button class="typo-butt-command mr-1 ml-1 mt-3 but-oval" @click="apriCreaaggregazione">
      <i class="fas fa-1x fa-layer-aggreg mr-2" style="color:#009DE0"></i>
      {{$t("create_aggreg_button.text")}}
    </b-button>

    <!-- Parametri impianto Modal-->
    <b-modal
      ok-only
      ref="modal"
      :id="'modal-crea-aggregazione'+this._uid"
      :title="$t('create_aggreg_modal.title')"
      :ok-title="$t('create_aggreg_modal.button_salva')"
      @ok="handleOk"
    >

    <!-- crea aggregazione form -->
      <b-row>
        <b-form-aggreg class="ml-5 mt-2 mb-5">
            
            <!--select existing aggreg -->
            <b-row v-if ="!this.add_aggreg">
              <b-col cols="10">
                <label class="h6 float-left mt-2">{{$t("create_aggreg_modal.select_aggreg")}}</label>
              </b-col> 
              <b-col cols="2">  
                  <i class="float-left fas fa-2x fa-plus-circle" style="color:#009DE0" @click="newaggreg"></i>
              </b-col>
              <b-col cols="10 mt-3">
                <b-form-select v-model="aggreg_selected" :options="aggreg_list"></b-form-select>
              </b-col>   
            </b-row>

            <!--add new aggreg -->
            <b-row v-if ="this.add_aggreg">
              <b-col cols="12">
                <label class="h6 float-left mt-2">{{$t("create_aggreg_modal.input_new_aggreg")}}</label>
              </b-col> 
              <b-col cols="10">
                <b-input v-model="input_aggreg"></b-input>
              </b-col>
              <b-col cols="2">
                <i class="float-left fas fa-1x fa-close mt-2" style="color:#009DE0" @click="closeInputaggreg"></i>
              </b-col>
            </b-row>
        </b-form-aggreg>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CreaAggregazione",
  data() {
    return {
      add_aggreg:false,
      input_aggreg:"",  

      aggreg_selected:"",
      aggreg_list: [
              { value: "aa", text: "aa" },
              { value: "bb", text: "bb" }
      ]
    };
  },
  props: {
    cu:null,
    lamp:null,
    sendAction: null
  },
  methods: {
     newaggreg()
     {
       this.add_aggreg=true; 
     },
     closeInputaggreg()
     {
       this.add_aggreg=false; 
     },
     apriCreaaggregazione() {
      this.add_aggreg=false;
      this.$bvModal.show('modal-crea-aggregazione'+this._uid);
      if (this.cu.length>0 || this.lamp.length>0)
      {
        console.log("Selezionate", this.cu, this.lamp);
      }
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.dbSaveaggreg();
    },
    
    dbSaveAggregation() {
            if (!this.input_aggreg || this.input_aggreg=="") return; 

            this.$store.dispatch("dbSaveaggreg", {
                plantId: this.$store.state.currentPlant.id,
                aggregName: this.input_aggreg,
            });
            
            // Hide the modal manually
            this.$nextTick(() => {
              this.$refs.modal.hide();
            });
    }
  }
};
</script>
